import type { SourcePlatform } from '~entities/import-job/api/types';
import type { ClassColumnMappingTableData } from '~pages/classes/bulk-upload/types';
import type { ClassData } from '~pages/classes/bulk-upload/validation';

import { CLASS_MAPPING_TABLE_DATA } from './class-mapping-table-data';
import { resolvePreMappedColumn } from './resolve-pre-mapped-column';

export function buildClassColumnMappingTable(
  headers: Array<string>,
  csvRow: ClassData | undefined,
  classAliases: Record<string, string>,
  sourcePlatform: SourcePlatform,
): Array<ClassColumnMappingTableData> {
  return CLASS_MAPPING_TABLE_DATA.map((row) => {
    // Upload CSV: never auto-select — user maps every column.
    const selectedColumn =
      sourcePlatform === 'csv'
        ? ''
        : resolvePreMappedColumn(
            row.header,
            headers,
            classAliases,
            sourcePlatform,
          );
    return {
      ...row,
      selectedColumn,
      columnValue:
        selectedColumn && csvRow
          ? String(csvRow[selectedColumn as keyof ClassData] ?? '')
          : '',
    };
  });
}
